<template lang="html">
  <div>
    <canvas ref="canvas" :height="graphHeight" />
    <div ref="legend" />
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'ProfileGraph',

  components: {

  },

  props: {
    colors: {
      type: Array,
      required: false,
      default: () => {
        return [
          '#c0372c', '#87b451', '#2087a1', '#FCE420', '#483698'
        ]
      }
    },
    options: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    data: {
      type: [Array, Object],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    animate: {
      type: Boolean,
      required: false,
      default: () => { return true }
    },
    xLabels: {
      type: Array,
      required: false,
      default: () => {
        return [
          'Never',
          'Seldom',
          'Sometimes',
          'Usually',
          'Always'
        ]
      }
    },
    yLabels: {
      type: Object,
      required: true
    },
    reverse: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    },
    showLegend: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    }
  },

  data () {
    return {}
  },

  computed: {
    graphHeight () {
      var pixels = Object.keys(this.data).length * 50
      return `${pixels}px`
    },

    defaultOptions () {
      return {
        legendCallback: function (chart) {
          var openingDiv = '<div>'
          var inner = '<h1 class="text-dark" onclick="' + this.onLegClick + '"></h1>'
          var closingDiv = '</div>'
          return openingDiv.concat(inner, closingDiv)
        },
        tooltips: {
          enabled: false
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value, index, values) => {
                  if (this.orderedXLabels[index]) {
                    return this.orderedXLabels[index]
                  }
                  return value
                },
                stepSize: 1,
                max: 4
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                callback: (value, index, values) => {
                  if (this.yLabels[value]) {
                    return this.yLabels[value]
                  }
                  return value
                }
              }
            }
          ]
        }
      }
    },
    internalOptions () {
      return {
        ...this.defaultOptions,
        ...this.options
      }
    },
    labelData () {
      return Object.keys(this.data)
    },
    dataData () {
      var formattedData = []
      Object.values(this.data).forEach((data, key) => {
        var labels = this.labelData
        formattedData.push({
          label: this.yLabels[labels[key]],
          data: [data],
          backgroundColor: [this.colors[key]]
        })
      })
      return formattedData
    },
    orderedXLabels () {
      if (this.reverse) {
        // eslint-disable-next-line
        return this.xLabels.reverse()
      }
      return this.xLabels
    }
  },

  watch: {

  },

  mounted () {
    this.setDefaults()
    this.draw()
  },

  methods: {
    setDefaults () {
      Chart.defaults.global.legend.display = this.showLegend
      if (!this.animate) {
        Chart.defaults.global.animation.duration = 0
      }
    },

    draw () {
      // eslint-disable-next-line
      var chart = new Chart(this.$refs.canvas, {
        type: 'horizontalBar',
        data: {
          labels: [''],
          datasets: this.dataData
        },
        options: this.internalOptions
      })

      this.$refs.legend.innerHTML = chart.generateLegend()
    }
  }
}
</script>

<style lang="css">
</style>
